import { useContext } from 'react';
import { StoreProducts } from '../components';
import { StoreContext } from '../contexts/store.context';
import { StoreProviderValue } from '../models';

export function SweepstakesPage() {
   const { raffles, setRaffles } = useContext<StoreProviderValue>(StoreContext);

   return (
      <StoreProducts
         raffles={raffles}
         setRaffles={setRaffles}
         origin="store"
      />
   );
}
